import { render, staticRenderFns } from "./LocationProductDetailNew.vue?vue&type=template&id=21b04425&scoped=true"
import script from "./LocationProductDetailNew.vue?vue&type=script&lang=js"
export * from "./LocationProductDetailNew.vue?vue&type=script&lang=js"
import style0 from "./LocationProductDetailNew.vue?vue&type=style&index=0&id=21b04425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b04425",
  null
  
)

export default component.exports